import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../img/hero2-removebg-preview.png";

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative bg-blue-950 text-white text-center py-24 overflow-hidden"
    >
      {/* Background Image */}
      <img
        src={heroImage}
        alt="Hero Visual"
        className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none"
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-blue-900 bg-opacity-60"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4">
        <h1 className="text-3xl md:text-5xl font-bold leading-tight">
          Welcome to Benue Education Quality Assurance<br />
          and Examinations Board
        </h1>

        <p className="mt-4 text-lg font-semibold">
          Ensuring Quality Education for All
        </p>

        {/* Learn More */}
        <a
          href="#about"
          className="mt-6 inline-block bg-red-500 font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-red-600 transition"
        >
          Learn More
        </a>

        {/* --- MOBILE ANIMATED LINKS --- */}
        <div className="block md:hidden mt-8 space-y-4">
          {/* e-Dossier */}
          <a
            href="https://beqa.ng"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-block bg-[#1ABC9C] text-white font-bold py-3 px-6 rounded-lg shadow hover:bg-[#16A085] transition animate-pulse"
          >
            Visit Our e-Dossier Platform
          </a>

          {/* Exam Registration Portal */}
          <a
            href="https://www.bsebdirect.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-block bg-purple-600 text-white font-bold py-3 px-6 rounded-lg shadow hover:bg-purple-700 transition animate-pulse"
          >
            Visit Our Exam Registration Portal
          </a>

          {/* Job Vacancies */}
          <Link
            to="/vancancies"
            className="w-full inline-block bg-yellow-500 text-blue-900 font-bold py-3 px-6 rounded-lg shadow hover:bg-yellow-400 transition"
          >
            Job Vacancies
          </Link>
        </div>

        {/* --- DESKTOP ANIMATED CTA ROW --- */}
        <div className="hidden md:flex justify-center gap-6 mt-10">
          {/* DESKTOP ANIMATION CLASS */}
          {/* Subtle float + hover scale */}
          <style>{`
            .float-soft {
              animation: floatSoft 3s ease-in-out infinite;
            }
            @keyframes floatSoft {
              0% { transform: translateY(0px); }
              50% { transform: translateY(-6px); }
              100% { transform: translateY(0px); }
            }
          `}</style>

          <a
            href="https://beqa.ng"
            target="_blank"
            rel="noopener noreferrer"
            className="float-soft bg-[#1ABC9C] text-white font-semibold py-3 px-6 rounded-lg hover:scale-105 hover:bg-[#16A085] transition-transform duration-300"
          >
            Visit Our e-Dossier Platform
          </a>

          <Link
            to="/vancancies"
            className="float-soft bg-yellow-500 text-blue-900 font-semibold py-3 px-6 rounded-lg hover:scale-105 hover:bg-yellow-400 transition-transform duration-300"
          >
            Job Vacancies
          </Link>

          <a
            href="https://www.bsebdirect.com"
            target="_blank"
            rel="noopener noreferrer"
            className="float-soft bg-purple-600 text-white font-semibold py-3 px-6 rounded-lg hover:scale-105 hover:bg-purple-700 transition-transform duration-300"
          >
            Visit Our Exam Registration Portal
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
